import {
  IconStores,
  PageContainer,
  PageHeader,
  StyleProps,
} from "@touche-lts/panel-ui/dist";
import cl from "classnames";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { settings } from "../../config";
import { useRootStore } from "../../mobx-stores/store-provider";
import { ApiKeysTable } from "./index";
import styles from "./settings-page.module.scss";

interface SettingsPageProps extends StyleProps, RouteComponentProps {}

const SettingsPageComponent: React.FC<SettingsPageProps> = (props) => {
  const { className, style } = props;
  const {
    apiKeysTableStore: { generateApiKey },
    generalStore: { showSuccess },
    routingStore: { replace },
  } = useRootStore();

  const searchParams = new URLSearchParams(window.location.search);
  const status = searchParams.get("status");

  useEffect(() => {
    if (status === "success_agreement_created") {
      showSuccess("Agreement created successfully");
      replace("/settings");
    }
  }, [status, showSuccess, replace]);

  return (
    <PageContainer
      className={cl(className, styles.pageContainer)}
      style={style}
    >
      <PageHeader
        navSegments={[
          {
            icon: IconStores,
            label: "Settings",
            iconProps: { style: { marginBottom: -5 } },
          },
          {
            label: "API Key Manager",
          },
        ]}
        buttons={[
          {
            preset: "secondary",
            children: "Create Agreement",
            onClick: () => {
              try {
                const jwt = JSON.parse(window.localStorage.getItem("jwt"));
                const url = new URL(
                  settings.backofficeSite + "/shopify/agreements/add"
                );
                url.searchParams.set("token", jwt.accessToken || "");
                window.location.href = url.toString();
              } catch (error) {
                console.error(error);
              }
            },
          },
          {
            preset: "primary",
            children: "Generate API Keys",
            onClick: () => generateApiKey(),
          },
        ]}
      />
      <ApiKeysTable />
    </PageContainer>
  );
};

const SettingsPage = observer(SettingsPageComponent);
export { SettingsPage };
